import { InputWithLabel } from '@adotel/components'
import { Switch } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'

import { getTranslate } from '../../../../localization'
import { SessionConfiguration } from '../../../../types/iamSessions'
import useStyles from './index.styles'

type Props = {
  updateSessionConfigInput: SessionConfiguration
  setUpdateSessionConfigInput: React.Dispatch<
    React.SetStateAction<SessionConfiguration>
  >
}
const TwoFactorAuthentication = ({
  updateSessionConfigInput,
  setUpdateSessionConfigInput
}: Props) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Typography variant="h4" className={classes.header}>
        {getTranslate('Two-Factor Authentication')}
      </Typography>
      <Typography variant="h5" className={classes.subTitle}>
        {getTranslate('Require 2FA for all user accounts')}
      </Typography>
      <div className={classes.bottom}>
        <div className={classes.row}>
          <div>
            <Typography variant="h4" className={classes.header}>
              {getTranslate('Enforce 2FA')}
            </Typography>
            <Typography variant="h5" className={classes.subTitle}>
              {getTranslate(
                'Users will be required to set up two-factor authentication'
              )}
            </Typography>
          </div>
          <Switch
            color="primary"
            size="small"
            checked={updateSessionConfigInput.require2faForLogin}
            onChange={(event) =>
              setUpdateSessionConfigInput({
                ...updateSessionConfigInput,
                require2faForLogin: event.target.checked
              })
            }
          />
        </div>
        <div className={classes.row}>
          <div>
            <Typography variant="h4" className={classes.header}>
              {getTranslate('Enforce log out on permission change')}
            </Typography>
            <Typography variant="h5" className={classes.subTitle}>
              {getTranslate(
                'Users will be logged out when its permissions change'
              )}
            </Typography>
          </div>
          <Switch
            color="primary"
            size="small"
            checked={updateSessionConfigInput.forceLogoutOnPermissionChange}
            onChange={(event) =>
              setUpdateSessionConfigInput({
                ...updateSessionConfigInput,
                forceLogoutOnPermissionChange: event.target.checked
              })
            }
          />
        </div>
        <div>
          <InputWithLabel
            label={getTranslate('Maximum 2FA attempt')}
            helpertext={getTranslate(
              'Maximum number of unsuccessful 2FA attempts'
            )}
            value={updateSessionConfigInput.max2faAttempts}
            onChange={(event) => {
              const value = event.currentTarget.value
              if (!/^\d*$/.test(value)) return
              setUpdateSessionConfigInput({
                ...updateSessionConfigInput,
                max2faAttempts: Number(value)
              })
            }}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            inputSize={'small'}
            className={classes.input}
          />
          <InputWithLabel
            label={getTranslate('Maximum login attempt')}
            helpertext={getTranslate(
              'Maximum number of unsuccessful login attempts'
            )}
            value={updateSessionConfigInput.maxLoginAttempts}
            onChange={(event) => {
              const value = event.currentTarget.value
              if (!/^\d*$/.test(value)) return
              setUpdateSessionConfigInput({
                ...updateSessionConfigInput,
                maxLoginAttempts: Number(value)
              })
            }}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            inputSize={'small'}
            className={classes.input}
          />
        </div>
      </div>
    </div>
  )
}

export default TwoFactorAuthentication
